import { render } from "./PeopleFinderView.vue?vue&type=template&id=079bfdc9"
import script from "./PeopleFinderView.vue?vue&type=script&lang=js"
export * from "./PeopleFinderView.vue?vue&type=script&lang=js"
script.render = render

export default script